import { useParams } from 'react-router-dom';

import { DashboardsPage } from '../dashboards/DashboardsPage';

import PrivateEventDetailBody from './PrivateEventDetailBody';
import PrivateEventDetailHeader from './PrivateEventDetailHeader';
import PrivateEventLoadState from './PrivateEventLoadState';
import { usePrivateEvent } from './usePrivateEvent';

/**
 * PrivateEventDetailPage — mounted at `/admin/private-events/:id`. Opens from a
 * list row; shows the event's fields plus a crew section that reuses the
 * workshop `CrewSlotEditor`.
 */
export default function PrivateEventDetailPage() {
  const { id = '' } = useParams<{ id: string }>();
  const { data: event, isLoading, error } = usePrivateEvent(id);

  if (isLoading || error || !event) {
    return <PrivateEventLoadState loading={isLoading} error={error} />;
  }

  return (
    <DashboardsPage
      header={
        <PrivateEventDetailHeader clientName={event.clientName} lifecycle={event.lifecycle} />
      }
      stack={false}
    >
      <PrivateEventDetailBody event={event} />
    </DashboardsPage>
  );
}
